import ServiceDigital from './ServiceDigital';
export default ServiceDigital;
